import { HttpHeaders } from "@angular/common/http";

export const defaultHttpOptionsJson = {
    headers: new HttpHeaders({'Content-Type': 'application/json'}),
};

export const credentialHttpOptionsJson = {
    headers: new HttpHeaders({'Content-Type': 'application/json'}),
    withCredentials: true
};